import React from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  ThemeProvider,
  Typography,
} from "@material-ui/core";

const contents: {
  [key: string]: {
    message: string;
    cancel: string;
    confirm: string;
  };
} = {
  default: {
    message: "You're about to leave the page",
    cancel: "Cancel",
    confirm: "Confirm",
  },
  cancel_request: {
    message:
      "Data will be removed, are you sure you want to cancel the request?",
    cancel: "No",
    confirm: "Yes, cancel request",
  },
};

export const Confirm: React.FC<{
  open: boolean;
  close: () => void;
  onConfirm: () => void;
}> = (props) => {
  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      open={props.open}
      onClose={() => props.close()}
    >
      <DialogContent dividers>
        <Typography>
          Data will be removed, are you sure you want to cancel the request?
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={() => props.close()}>
          No
        </Button>
        <Button
          onClick={() => {
            props.onConfirm();
            props.close();
          }}
        >
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
};
